var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleList',{staticClass:"notice-type-rows",attrs:{"rows":_vm.rows,"has-left-gutter":!!_vm.$isMobile}})}
var staticRenderFns = []

export { render, staticRenderFns }